import React from 'react';

const RenderDataCard = ({ data = {}, excludeKeys = [] }) => {
    const defaultExcludedKeys = ['_id', 'SID', 'Archive', 'modOn', 'modBy', 'addOn', 'addBy'];
  const allExcludedKeys = [...new Set([...defaultExcludedKeys, ...excludeKeys])];

  const isObject = (val) => typeof val === 'object' && val !== null && !Array.isArray(val);

  return (
    <div className="d-flex flex-wrap gap-3">
      {Object.entries(data)
        .filter(([key]) => !allExcludedKeys.includes(key))
        .map(([key, value], index) => {
          return (
            <div
              key={`field-${index}`}
              className="bg-light border rounded p-2 h-100 d-flex flex-column"
              style={{ minWidth: '200px', maxWidth: '350px', flexGrow: 1 }}
            >
              <p className="text-uppercase text-muted mb-1 fw-semibold">{key}</p>

              {/* Handle arrays */}
              {Array.isArray(value) ? (
                value.length === 0 ? (
                  <pre className="text-dark mb-0 text-break">[]</pre>
                ) : (
                  <div className="ms-2">
                    {value.map((item, idx) =>
                      isObject(item) ? (
                        <RenderDataCard
                          key={`array-item-${idx}`}
                          data={item}
                          excludeKeys={allExcludedKeys}
                        />
                      ) : (
                        <pre
                          key={`array-item-text-${idx}`}
                          className="text-dark mb-0 text-break"
                          style={{ whiteSpace: 'pre-wrap', margin: 0 }}
                        >
                          {item}
                        </pre>
                      )
                    )}
                  </div>
                )
              ) : isObject(value) ? (
                // If value is object, recursively render nested cards
                <RenderDataCard data={value} excludeKeys={allExcludedKeys} />
              ) : (
                // Otherwise just render text value
                <pre
                  className="text-dark mb-0 text-break"
                  style={{
                    whiteSpace: 'pre-wrap',
                    maxHeight: '100px',
                    overflowY: 'auto',
                    margin: 0,
                  }}
                >
                  {value}
                </pre>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default RenderDataCard;
